import SlimSelect from 'slim-select'

export function slimselect(){
    document.querySelectorAll('select').forEach((item) => {
        new SlimSelect({
            select: item,
            settings: {
                showSearch: false,
                placeholderText: 'Custom Placeholder Text',
            }
        })
    })
}